
import React from 'react';
import { Button } from '@/components/ui/button';
import { Minus, Plus, Trash2 } from 'lucide-react';

interface QuantitySelectorProps {
  quantity: number;
  onQuantityChange: (quantity: number) => void;
  onRemove?: () => void;
  min?: number;
  max?: number;
  size?: 'default' | 'sm';
  disabled?: boolean;
}

export const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  quantity,
  onQuantityChange,
  onRemove,
  min = 1,
  max = 99,
  size = 'default',
  disabled = false
}) => {
  const handleDecrease = () => {
    if (quantity > min && !disabled) {
      onQuantityChange(quantity - 1);
    }
  };

  const handleIncrease = () => {
    if (quantity < max && !disabled) {
      onQuantityChange(quantity + 1);
    }
  };

  const buttonSize = size === 'sm' ? 'h-6 w-6' : 'h-8 w-8';
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';
  const spacing = size === 'sm' ? 'gap-1' : 'gap-2';

  return (
    <div className={`flex items-center ${spacing} bg-white border rounded-md p-1 ${
      disabled ? 'opacity-50 cursor-not-allowed' : ''
    }`}>
      <Button
        variant="ghost"
        size="sm"
        className={`${buttonSize} p-0 hover:bg-gray-100`}
        onClick={handleDecrease}
        disabled={quantity <= min || disabled}
      >
        <Minus className={size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} />
      </Button>
      
      <span className={`${textSize} font-medium min-w-[20px] text-center`}>
        {quantity}
      </span>
      
      <Button
        variant="ghost"
        size="sm"
        className={`${buttonSize} p-0 hover:bg-gray-100`}
        onClick={handleIncrease}
        disabled={quantity >= max || disabled}
      >
        <Plus className={size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} />
      </Button>
      
      {onRemove && (
        <Button
          variant="ghost"
          size="sm"
          className={`${buttonSize} p-0 hover:bg-red-50 text-red-500 ml-1`}
          onClick={onRemove}
          disabled={disabled}
        >
          <Trash2 className={size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'} />
        </Button>
      )}
    </div>
  );
};
